export default "__VITE_ASSET__a7a79d3f__"